export default __webpack_public_path__ + "static/media/ravi.f2c738c7.png";